/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const MapMatchCostingModel = {
  Auto: "auto",
  Bus: "bus",
  Taxi: "taxi",
  Truck: "truck",
  Bicycle: "bicycle",
  Bikeshare: "bikeshare",
  MotorScooter: "motor_scooter",
  Motorcycle: "motorcycle",
  Pedestrian: "pedestrian",
  LowSpeedVehicle: "low_speed_vehicle",
} as const;
export type MapMatchCostingModel =
  (typeof MapMatchCostingModel)[keyof typeof MapMatchCostingModel];

export function instanceOfMapMatchCostingModel(value: any): boolean {
  for (const key in MapMatchCostingModel) {
    if (Object.prototype.hasOwnProperty.call(MapMatchCostingModel, key)) {
      if (
        MapMatchCostingModel[key as keyof typeof MapMatchCostingModel] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function MapMatchCostingModelFromJSON(json: any): MapMatchCostingModel {
  return MapMatchCostingModelFromJSONTyped(json, false);
}

export function MapMatchCostingModelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MapMatchCostingModel {
  return json as MapMatchCostingModel;
}

export function MapMatchCostingModelToJSON(
  value?: MapMatchCostingModel | null,
): any {
  return value as any;
}

export function MapMatchCostingModelToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): MapMatchCostingModel {
  return value as MapMatchCostingModel;
}
